import React,{Component} from 'react'
import {Table, Row, Col} from 'react-bootstrap'
import {ToNotify} from 'fast_inon'
import {OnUpdate} from '../../components/Shared/ActionControl'
import { toDate } from '../../components/Shared/Formating'

class NoteTable extends Component{

    constructor (props){
        super(props)
        this.state = { notify:{open:false, message:''}, itemId:0, sections:""}
        this.entity='note'
    }

    componentDidMount(){
        this.props.LoadNotes()
    }

    componentDidUpdate(){
        if(this.state.sections!==this.props.sections) {
            //console.log('componentDidUpdate',this.props.sections)
            this.props.LoadNotes()
            this.setState({sections:this.props.sections})
        }
    }
    

    Add() {
        let ss = this.props.sections.split('-',)
        //console.log("Add note : ",this.props.sections, ss)

        if(ss && ss.length>1) {
            fetch(`${this.props.global.apiUrl+this.entity}`,{
                method:'POST',
                headers:this.props.global.headers,
                body:JSON.stringify({
                    Text:'New',
                    SectionId:ss[1]
                })
            })
            .then(response => response.json())
            .then(
                
                (result)=>{
                    //console.log('AddNote result ?', result)
                    this.setState({notify:{open:true, message:result.message}})

                    if(result?.message && result.message.endsWith("!"))
                        this.props.LoadNotes()
                },
                (error)=>{
                    //console.log('AddNote error ?', error)
                    this.setState({notify:{open:true, message:error.message}})
                }
            )
        }
        else
            this.setState({notify:{open:true, message:'You have to select a section ...'}})
    }

    onNote(id, editing=false) {
        if(id>0) {
            this.state ?? this.setState({itemId:id})
            this.props.onNote(id, editing) 
        }
    }
    
    render() {

        return (
            <div className="Notes" size="lg">

<ToNotify 
message={this.state.notify.message}
onClose={()=>{this.setState({notify:{open:false, message:''}})}}
/>                
<OnUpdate onAdd={()=> this.Add()} />
<Table>

<tbody>
    {
        this.props.notes.map(item=>
            <tr key={item.Id}>

<NoteItem id={item.Id} section={item.SectionId} value={item.Text} date={toDate(item.Updated)} onClick={()=> this.onNote(item.Id)} 
    style={this.props.sectionStyle(item.SectionId)} 
    />

            </tr>
            )
    }
</tbody>
</Table>

</div>
        )
    }
}

const NoteItem = ({id, value, date, onClick, style}) => {

    let fstyle= {...style, opacity:1, border:0}

    //let color=sectionStyle(section)
    //alert(color)
    return (
        <td key={id} value={value} style={{border:0, padding:'0.3rem'}}> 
            <Col style={fstyle}>
            <Row style={{margin:'0'}} onClick={onClick}>
            <Col sm={6} style={{fontSize: '1rem', fontWeight: 'bold', color:'silver' }} >{id}</Col>
            <Col sm={6} style={{fontSize: '0.7rem', textAlign:'right', color:'cyan'}}>{date}</Col>
            </Row>
            <Row onClick={onClick} style={{padding: '0.5rem 1rem'}}>
                <textarea theme="bubble" className="Viewing" rows="1" style={{backgroundColor:'transparent', color:'white'}}
                    value={value} readOnly={true} />
            </Row>
          </Col>
        </td>
    )
}

export {NoteTable, NoteItem};
